export const PLATFORMS = ["mac", "windows"] as const;

export type Platform = (typeof PLATFORMS)[number];

export interface DeviceOption {
  id: string;
  make: string;
  model: string;
  specsLine: string;
  platform: Platform;
}

export interface DeviceOptions {
  options: DeviceOption[];
  keyboardLayouts: string[];
}
